import React from 'react';
import SocialProfileStep from './SocialProfileStep';
import SocialLinkCodeStep from './SocialLinkCodeStep';

/**
 * B-53: the one extra screen an Apple/Google sign-in can need — the DOB +
 * terms step for someone new, or the emailed-code step before a non-Gmail
 * Google address may link an existing account. Same props for both.
 */
const SocialPendingStep = ({ pending, onDone, onCancel, title }) => (pending.needsEmailCode
  ? <SocialLinkCodeStep pending={pending} onDone={onDone} onCancel={onCancel} />
  : <SocialProfileStep pending={pending} onDone={onDone} onCancel={onCancel} title={title} />);

export default SocialPendingStep;
